var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c("div", { staticClass: "wrapper", on: { click: _vm.onClose } }, [
        _c(
          "div",
          { class: { wrapper_body: true }, attrs: { id: "globalModal" } },
          [
            _c(
              "div",
              {
                class: {
                  modal_body: true,
                  small: _vm.incomeData?.drawer?.small,
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-default btn-sm position-absolute close_btn",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.onClose(null, true)
                      },
                    },
                  },
                  [_c("i", { staticClass: "icon-fa icon-fa-close" })]
                ),
                _vm._v(" "),
                _vm.incomeData.type === "filesPreview"
                  ? [
                      _c("PreviewPage", {
                        attrs: { files: _vm.incomeData.files },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "pairSMSToOrder"
                  ? [
                      _c("PairSMS", {
                        attrs: {
                          orderId: _vm.incomeData.orderId,
                          cardId: _vm.incomeData.cardId,
                          closeDrawer: _vm.onClose,
                        },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "prePaid"
                  ? [
                      _c("PrePaidManage", {
                        attrs: {
                          order: _vm.incomeData.order,
                          closeDrawer: _vm.onClose,
                        },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "editServicePhone"
                  ? [
                      _c("EditPhone", {
                        attrs: {
                          phone: _vm.incomeData.phone,
                          callBackAction: _vm.callBackAction,
                          closeDrawer: _vm.onClose,
                        },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "editCreditCardUser"
                  ? [
                      _c("EditUser", {
                        attrs: {
                          user: _vm.incomeData.user,
                          callBackAction: _vm.callBackAction,
                          closeDrawer: _vm.onClose,
                        },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "editOrderInvoice"
                  ? [
                      _c("EditOrderInvoice", {
                        attrs: {
                          id: _vm.incomeData.invoiceId,
                          callBackAction: _vm.callBackAction,
                          closeDrawer: _vm.onClose,
                        },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "editInvoice"
                  ? [
                      _c("EditInvoice", {
                        attrs: {
                          invoiceId: _vm.incomeData.invoiceId,
                          callBackAction: _vm.callBackAction,
                          closeDrawer: _vm.onClose,
                        },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "storeAdjustmentsByDrug"
                  ? [
                      _c("AdjustInvoices", {
                        attrs: {
                          drug: { id: _vm.incomeData.drugId },
                          callBackAction: _vm.callBackAction,
                          closeDrawer: _vm.onClose,
                        },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "storeDrugMoves"
                  ? [
                      _c("DrugMoves", {
                        attrs: {
                          data: _vm.incomeData.drugData,
                          storeId: _vm.incomeData.storeId,
                          inStore: _vm.incomeData.inStore,
                          callBackAction: _vm.callBackAction,
                          closeDrawer: _vm.onClose,
                        },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "drugEditSite"
                  ? [
                      _c("DrugSiteEdit", {
                        attrs: {
                          hideSelect: true,
                          loadDrug: { ..._vm.incomeData },
                        },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "dialogs"
                  ? [
                      _c("OrdersChat", {
                        attrs: { orderId: _vm.incomeData.orderId },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "drugDetailCopy"
                  ? [
                      _c("DetailCopy", {
                        attrs: {
                          drugId: _vm.incomeData.drugId,
                          drugDetailId: _vm.incomeData.detailId,
                          closeDrawer: _vm.onClose,
                        },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "DrugStatisticMultiTask"
                  ? [
                      _c("MultiTaskFromStat", {
                        attrs: {
                          record: _vm.incomeData.record,
                          task: _vm.incomeData.task,
                          closeDrawer: _vm.onClose,
                        },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "ClientIncomeRequest"
                  ? [
                      _c("ClientRequest", {
                        attrs: {
                          data: _vm.incomeData.data,
                          closeDrawer: _vm.onClose,
                        },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "orderDetailsForRunner"
                  ? [
                      _c("RunnerOrderDetails", {
                        attrs: { orderId: _vm.incomeData.orderId },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "priceChangeTasks"
                  ? [
                      _c("UpdateDrugStatusPrice", {
                        attrs: { tasks: _vm.incomeData.records },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "drugTasks003"
                  ? [
                      _vm.incomeData.task.type_id === 22
                        ? [
                            _c("ManufacturerDrugInfoTask", {
                              attrs: { task: _vm.incomeData.task },
                            }),
                          ]
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "ActivationDrugDelay"
                  ? [
                      _c("ActivationDrugDelay", {
                        attrs: { drug: _vm.incomeData.drug },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "storeDrugTrends"
                  ? [
                      _c("StoreTrends", {
                        attrs: { drug: _vm.incomeData.drug },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "ChatReplySnippets"
                  ? [
                      _c("ChatReplySnippets", {
                        attrs: {
                          onSelect: (m) => {
                            _vm.callBackAction(m)
                            this.onClose(null, true)
                          },
                        },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.incomeData.type === "taskView"
                  ? [_vm._v("\n        TASK VIEW\n        ")]
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }